import create from 'zustand';

import { IAppState } from './types';

const useAppState = create<IAppState>()((set) => ({
  file: null,
  blobUrl: '',
  uploadError: null,
  isProcessing: false,
  flipDirection: null,
  canvasImageUrl: undefined,
  imageName: undefined,
  canvasImageFile: null,
  flipedHorizontally: false,
  flipedVertically: false,
  isOpen: false,
  isDownloaded: false,

  addImage: (file, blobUrl) =>
    set((state) => ({
      ...state,
      file,
      blobUrl,
      imageName: file.name,
      isProcessing: true,
      displayUploadSuccess: true,
    })),

  deleteImage: () =>
    set(() => ({
      file: null,
      blobUrl: '',
      uploadError: null,
      isProcessing: false,
      flipDirection: null,
      imageName: undefined,
      canvasImageFile: null,
      isOpen: false,
    })),

  setUploadError: (uploadError) =>
    set((state) => ({
      ...state,
      uploadError,
      isProcessing: false,
    })),

  setIsProcessing: (isProcessing) =>
    set((state) => ({
      ...state,
      isProcessing,
    })),

  setFlipDirection: (flipDirection) =>
    set((state) => ({
      ...state,
      flipDirection,
    })),

  setCanvasImageFile: (canvasImageFile) =>
    set((state) => ({
      ...state,
      canvasImageFile,
    })),
  setFlipedHorizontally: (flipedHorizontally) =>
    set((state) => ({
      ...state,
      flipedHorizontally,
    })),
  setFlipedVertically: (flipedVertically) =>
    set((state) => ({
      ...state,
      flipedVertically,
    })),

  setIsOpen: (isOpen) =>
    set((state) => ({
      ...state,
      isOpen,
    })),
  setIsDownloaded: (isDownloaded) =>
    set((state) => ({
      ...state,
      isDownloaded,
    })),
}));

export default useAppState;
